// Supabase service for HKDSE Q&A Data
// Replaces hkdseQAData.js and hkdseQADataTypeA-E.js imports

import { querySupabase } from '../supabaseClient';

/**
 * Get Q&A data by text ID (main function that tries all types)
 */
export const getQAByTextId = async (textId) => {
  try {
    const records = await querySupabase('chi_quizqadata', { text_id: textId }, {
      order_by: 'section_type',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return null;
    
    // Transform Supabase records to component-friendly format
    const firstRecord = records[0];
    
    // Group by section_type
    const sections = {};
    
    records.forEach(record => {
      const sectionType = record.section_type;
      const sectionTitle = record.section_title;
      
      if (!sections[sectionType]) {
        sections[sectionType] = {
          title: sectionTitle,
          content: []
        };
      }
      
      // Handle different section types
      if (sectionType === 'paragraphStructure') {
        // Group by subsection_title for paragraph structure
        const subsectionTitle = record.subsection_title || '段落內容';
        let subsection = sections[sectionType].content.find(
          s => s.subtitle === subsectionTitle
        );
        
        if (!subsection) {
          subsection = {
            subtitle: subsectionTitle,
            points: []
          };
          sections[sectionType].content.push(subsection);
        }
        
        // Add point (question/answer becomes a point item)
        subsection.points.push({
          title: '內容重點',
          items: [record.answer_text]
        });
      } else if (sectionType === 'selectedQuestions') {
        // For selected questions, ensure questions array exists
        if (!sections[sectionType].questions) {
          sections[sectionType].questions = [];
        }
        
        sections[sectionType].questions.push({
          question: record.question_text,
          answer: record.answer_text
        });
      } else {
        // For other section types, add as content items
        if (!sections[sectionType].content) {
          sections[sectionType].content = [];
        }
        sections[sectionType].content.push({
          title: record.question_text,
          items: [record.answer_text]
        });
      }
    });
    
    return {
      title: firstRecord.title,
      sections
    };
  } catch (error) {
    console.error('Error fetching Q&A data:', error);
    return null;
  }
};

/**
 * Get Type A Q&A by text ID
 */
export const getTypeAQAByTextId = async (textId) => {
  return getQAByTextId(textId);
};

/**
 * Get Type B Q&A by text ID
 */
export const getTypeBQAByTextId = async (textId) => {
  return getQAByTextId(textId);
};

/**
 * Get Type C Q&A by text ID
 */
export const getTypeCQAByTextId = async (textId) => {
  return getQAByTextId(textId);
};

/**
 * Get Type D Q&A by text ID
 */
export const getTypeDQAByTextId = async (textId) => {
  return getQAByTextId(textId);
};

/**
 * Get Type E Q&A by text ID
 */
export const getTypeEQAByTextId = async (textId) => {
  return getQAByTextId(textId);
};

